module.exports = __webpack_public_path__ + "static/media/sample-evoucher-email.4215e5c3.png";